// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-post-banner-data-sec {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(52, 64, 84, 0.7);
  top: 0;
}
.campaign-post-banner-data-sec.small-post-banner .post-banner-data {
  width: 350px;
  max-height: 400px;
}
.campaign-post-banner-data-sec.small-post-banner .post-banner-data .banner-img-data {
  max-height: 358px;
}
.campaign-post-banner-data-sec .post-banner-data {
  border-radius: 4px;
  background: var(--gray-50, #F9FAFB);
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  width: 500px;
  max-width: 500px;
  max-height: 600px;
  min-height: 400px;
}
.campaign-post-banner-data-sec .post-banner-data .header-block-info {
  border-radius: 4px;
  background: var(--base-white, #FFF);
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.campaign-post-banner-data-sec .post-banner-data .header-block-info .close-post-banner {
  flex-shrink: 0;
  line-height: 0;
  font-size: 16px;
  cursor: pointer;
  background: transparent;
  padding: 0;
  border: 0;
  margin-left: auto;
}
.campaign-post-banner-data-sec .post-banner-data .banner-img-data {
  max-height: 558px;
  overflow-y: auto;
  padding: 16px 24px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/proactiveWebCampaign/templates/pwcPostTemplate/pwcPostTemplate.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,MAAA;AAAJ;AAEQ;EACI,YAAA;EACA,iBAAA;AAAZ;AACY;EACI,iBAAA;AAChB;AAGI;EACI,kBAAA;EACA,mCAAA;EACA,8FAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AADR;AAEQ;EACI,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAZ;AACY;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;AAChB;AAEQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAZ","sourcesContent":["\n.campaign-post-banner-data-sec{\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    z-index: 9999999;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(52, 64, 84, 0.70);\n    top: 0;\n    &.small-post-banner{\n        .post-banner-data{\n            width: 350px;\n            max-height: 400px;\n            .banner-img-data{\n                max-height: 358px;\n            }\n        }\n    }\n    .post-banner-data{\n        border-radius: 4px;\n        background: var(--gray-50, #F9FAFB);\n        box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);\n        width: 500px;\n        max-width: 500px;\n        max-height: 600px;\n        min-height: 400px;\n        .header-block-info{\n            border-radius: 4px;\n            background: var(--base-white, #FFF);\n            padding: 10px;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            .close-post-banner{\n                flex-shrink: 0;\n                line-height: 0;\n                font-size: 16px;\n                cursor: pointer;\n                background: transparent;\n                padding: 0;\n                border: 0;\n                margin-left: auto;\n            }\n        }\n        .banner-img-data{\n            max-height: 558px;\n            overflow-y: auto;\n            padding: 16px 24px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
